export default class PersonAddressArchivedDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
}
